module.exports = __webpack_public_path__ + "media/components/src/assets/images/dot/dot_02-a36eb177a473e493d3aade6969118513.svg";